import { Spinner } from "@material-tailwind/react";

export function DefaultSpinner() {
  return <Spinner />;
}
